<script>
  let {buttonToggle} = $props();
</script>

<div class="button-item">
  <button class="button owd-text:02" onclick={buttonToggle}>
  閉じる
  </button>
</div>


<style lang="scss">

  .button-item {
    margin: 0 auto;
    text-align: center;
    margin-top: 80px;
  }
  .button {
    font-weight: 600;
    text-align: center;
    margin: 0 auto;
    padding: 0;
    background: transparent;
    border: 0;
    display: inline-block;
    padding-bottom: 5px;
    border-bottom: 1px dashed #000;

  }
</style>
